import { BasePathProvider, useBasePath } from "components/Providers"
import { useLocation } from "react-router-dom";
import PunchApprovalForm from "./PunchRequestForm";

export default function PunchApprovalFormIndex() {
  const basePath = useBasePath();
  const location = useLocation();
  const record = location.state?.record;

  return (
    <BasePathProvider value={basePath}>
      <PunchApprovalForm record={record} />
    </BasePathProvider>
  )
}
